



import Vue from 'vue'

export default Vue.extend({
    props: {
        id: {
            type: String,
        },
        url: {
            type: String,
        },
    },
    data() {
        return {
            videoList: []as any,
        }
    },
    mounted() {
    }
})
